<template>
<div>
  <div :style="{ padding: ' 20px',width:'1000px',margin:'auto'}">
    <router-view></router-view>
  </div>
  </div>
</template>
<script>
export default {
  data(){
    return{}
  },
  watch:{
    
  },
  methods:{}
}
</script>
<style scoped>
.wellcome {
  color: #2d76f9;
  font-weight: 700;
  font-size: 20px;
}
.indexButton_baoming,.indexButton_chengji{
  height: 98px;
  width: 240px;
  margin: 40px 20px;
  background: linear-gradient(
    119.42deg,
    rgba(86, 204, 242, 1) 0%,
    rgba(45, 118, 249, 1) 100%
  );
   background: url("../assets/index/commit2.png") no-repeat top;
  background-size: 100% auto;
  border-radius: 6px;
  /* box-shadow: 0px 1.58px 1.51px rgba(182, 196, 250, 0.75); */
  color: white;
  font-weight: 500;
  font-size: 18px;
  line-height: 98px;
  /* letter-spacing: 5px; */
  display: inline-block;
}
</style>